import { Routes, Route } from 'react-router-dom'
import Navbar from './Navbar/Navbar'
import Home from '../pages/Home/Home'
import Employees from '../pages/Employees/Employees.jsx'

/**
 * Layout
 * Handling web app routes
 * @returns routes
 */

function Layout() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path="/employees" element={<Employees />} />
      </Routes>
    </>
  )
}

export default Layout
